type LinkedEntry = { siteid: string; value: Record<string, unknown> };

// Label.tsx (label[]) and LinkedSites.tsx (linked[]) edit one site's `value`
// the same way (SCRUM-2279). The stored entry is frozen (SCRUM-1954), so the
// edited entry is a copy, moved to the front of the list.
export const changeLinkedValue = <T extends LinkedEntry>(
  list: T[],
  siteID: string,
  name: string,
  value: unknown,
): T[] => {
  const storedLink = list.filter((linkedSite) => linkedSite.siteid === siteID)[0];
  const targetLink = {
    ...storedLink,
    value: { ...storedLink.value, [name]: value },
  };
  return [targetLink, ...list.filter((linkedSite) => linkedSite.siteid !== siteID)];
};
